import { useIntl } from "react-intl";
import PageInfo from "./PageInfo";

function FertilizerPropertiesInfo() {
  const { formatMessage } = useIntl();

  return (
    <PageInfo>
      <div
        className="sensor-properties-info"
        dangerouslySetInnerHTML={{
          __html: formatMessage({ id: "fertilizer.properties.info" }),
        }}
      />
    </PageInfo>
  );
}

export default FertilizerPropertiesInfo;
